import VForm from '@/vuetify_custom/v-form'
export default {
    data() {
        return {
            de_params: {
                reason: '',
            }
        }
    },
    methods: {
        del(data) {
            this.de_params.id = data.id
            this.de_params.reason = ''
          
            return new Promise((resolve, reject) => {
                this.$nextTick(() => {
                    this.delApProxy(resolve, reject)
                })
            })
        },
        delApProxy(resolve, reject) {
            this.$vModal.confirm({
                title: '废弃',
                loading: true,
                render: () => {
                    return <div>
                        <VForm
                            ref="form" 
                            fields={[
                                {
                                    label: '废弃原因', 
                                    key:'reason',
                                    type:'textareas_field',
                                    rows: 4,
                                }
                            ]}
                            v-model={this.de_params}
                        />
                    </div>
                },
                onOk:({destroy, stopLoading}) => {
                    if (!this.de_params.reason) {
                        stopLoading()
                        this.$Message.error('废弃原因必须填写！')
                        return 
                    }
                    this.delApi(this.de_params)
                    .then(r => resolve(r))
                    .catch(e => reject(e))
                    .finally(destroy)
                }
            })
        }

    }
}